import kythuat1 from "../../../assets/images/KyThuat/1.png";
import kythuat2 from "../../../assets/images/KyThuat/2.png";
import kythuat3 from "../../../assets/images/KyThuat/3.png";
import kythuat4 from "../../../assets/images/KyThuat/4.png";
import kythuat5 from "../../../assets/images/KyThuat/5.png";
const banKyThuat = {
  title: "Ban",
  name: "Kỹ Thuật",
  registerMes:
    "Bấm đăng kí để có cơ hội trở thành thành viên của ban kỹ thuật nhé",
  clb: "student informatic club",
  btn: "Đăng kí CTV",
  imagesIntro: [kythuat1, kythuat2, kythuat3, kythuat4, kythuat5],
  mission: [
    `Hỗ trợ sinh viên, thầy cô trong việc lặp đặt và sửa chữa vấn đề phát sinh trong việc sử dụng máy tính`,
    `Tổ chức các sự kiện sửa máy tính, vệ sinh laptop miễn phí`,
    `Bổ sung kiến thức cần thiết về máy tính, đặc biệt là về phần cứng cho sinh viên`,
  ],
  advantage: [
    `Nâng cao kiến thức, hoàn thiện bản thân`,
    `Rèn luyện tinh thần học hỏi, tinh thần trách nghiệm`,
    `Đặc biệt được tiếp xúc, trau dồi kiến thức và kĩ năng liên quan đến máy tính`,
    `Là nơi lý tưởng để tìm kiếm tri kỉ cùng chung sở thích về máy móc`,
  ],
};

export default banKyThuat;
